import {
  LogoContainer,
  LogoImage,
  MoreInformationWrapper,
  SectionRoot,
} from './styles';
import { useMobileWidth } from '@utils/hooks';
import { getImageSrc } from '@utils/fn';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Icon from '@components/Icon';

interface Logo {
  id: string;
  logo: string;
  name: string;
}

export interface LogoGaleryProps {
  items: Logo[];
}

const LogoGalery = ({ items }: LogoGaleryProps) => {
  const isMobile = useMobileWidth();
  const [showAll, setShowAll] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  const visibleItems = isMobile && !showAll ? items.slice(0, 10) : items;

  return (
    <section>
      <SectionRoot>
        {visibleItems.map(item => (
          <LogoContainer key={item?.id}>
            <LogoImage src={item?.logo} alt={item?.name} loading="lazy" />
          </LogoContainer>
        ))}
      </SectionRoot>

      {isMobile && items.length > 10 && (
        <MoreInformationWrapper
          onClick={() => {
            setShowAll(prev => !prev);
          }}
        >
          {t(showAll ? 'show-less' : 'show-more')}
          <Icon
            name={`event-pages_${showAll ? 'up' : 'down'}-arrow`}
            color={theme.color.mobilityGrey}
            indentLess
            size={25}
          />
        </MoreInformationWrapper>
      )}
    </section>
  );
};

export default LogoGalery;
